import { Carousel, Embla } from "@mantine/carousel";
import {
  Alert,
  Container,
  createStyles,
  Flex,
  Group,
  Loader,
  Progress,
  Text,
  Title,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { useCallback, useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useParams } from "react-router-dom";
import { SurveyNavigationButtons } from "./_surveyNavigationButtons";
import {
  SurveyWelcome1,
  SurveyWelcome2,
  SurveyAcknowledgement,
  InformacionPersonal,
  InformacionLaboralFija,
  InformacionLaboralPersonalizable,
  SurveyInfoPolitics,
  SistemaDePrevencion,
  SurveyInfoSituations,
  ToleranciaAcosoSexual,
  ToleranciaAcosoLaboral,
  //
  Conceptos,
  SurveyInfoPersonalExperience,
  HaSidoObjetoDeAcosoSexual,
  FrecuenciaAcosoSexual,
  GeneroAcosadorAcosoSexual,
  PreguntasPerfilAcosadorAcosoSexual,
  AccionesAcosoSexual,
  BarrerasDeDenunciaAcosoSexual,
  HaSidoObjetoDeAcosoLaboral,
  FrecuenciaAcosoLaboral,
  GeneroAcosadorAcosoLaboral,
  PreguntasPerfilAcosadorAcosoLaboral,
  AccionesAcosoLaboral,
  BarrerasDeDenunciaAcosoLaboral,
  HaSidoTestigoDeAcosoSexual,
  HaSidoTestigoDeAcosoLaboral,
  AccionesTestigos,
  SurveyInfoTratamientoDeCasos,
  PreguntasConfianzaEnLaOrganizacion,
  PreguntaSatisfaccion,
  SurveyInfoCasos,
  CasoAcosoSexual,
  CasoAcosoLaboral,
} from "./ELSA_5";
import { SurveyService } from "../../services";
import { TStaffSurveyDataELSA5 } from "../../types";
import { useLogo } from "../../context/Logo/LogoContext";
import i18n from "../../i18n";
import { ApiWithoutToken, BASE_URL } from "../../services/axios-instance";
import { useTranslation } from "react-i18next";
import {
  transformWorkplaceHarassmentSurveyData,
  WorkplaceHarassmentFormValues,
} from "../../utils/workplaceHarassmentDataTransform";

type Props = {
  isPreview: boolean;
  isDemoMode: boolean;
};

const useStyles = createStyles((theme) => ({
  carouselSlide: {
    overflowY: "auto",
    maxHeight: "500px",
    overflowX: "hidden",

    [`@media (max-width: ${theme.breakpoints.sm}px)`]: {
      maxHeight: "700px",
    },
  },
}));

export const SurveyPageWorkplaceHarassment = ({
  isPreview,
  isDemoMode,
}: Props) => {
  const { id: mpCode } = useParams();
  const [searchParams] = useSearchParams();

  const [scrollProgress, setScrollProgress] = useState(0);
  const [embla, setEmbla] = useState<Embla | null>(null);
  const [survey, setSurvey] = useState<TStaffSurveyDataELSA5>(null!);
  const [error, setError] = useState<string | null>(null);
  const [isLeader, setIsLeader] = useState<boolean>(false);
  const [esParteDeRecursosHumanos, setParteDeRecursosHumanos] =
    useState<boolean>(false);
  const [haSidoObjetoDeAcosoSexual, setHaSidoObjetoDeAcosoSexual] =
    useState<boolean>(false);
  const [haSidoObjetoDeAcosoLaboral, setHaSidoObjetoDeAcosoLaboral] =
    useState<boolean>(false);
  const [noDenuncioAcosoSexual, setNoDenuncioAcosoSexual] = useState(false);
  const [noDenuncioAcosoLaboral, setNoDenuncioAcosoLaboral] = useState(false);
  const [haSidoTestigoDeAcosoSexual, setHaSidoTestigoDeAcosoSexual] =
    useState<boolean>(false);
  const [haSidoTestigoDeAcosoLaboral, setHaSidoTestigoDeAcosoLaboral] =
    useState<boolean>(false);
  const [totalSlides, setTotalSlides] = useState<number>(0);
  const [encuestaVencida, setEncuestaVencida] = useState(false);
  const [encuestaTodaviaNoHaSidoLanzada, setEncuestaTodaviaNoHaSidoLanzada] =
    useState(false);
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();

  const { updateLogo } = useLogo();

  const navigate = useNavigate();

  const handleScroll = useCallback(() => {
    if (!embla) return;
    const progress = Math.max(0, Math.min(1, embla.scrollProgress()));
    setScrollProgress(progress * 100);
  }, [embla, setScrollProgress]);

  useEffect(() => {
    if (embla) {
      embla.on("scroll", handleScroll);
      handleScroll();
    }
  }, [handleScroll, embla]);

  const { classes } = useStyles();

  const validateField = (value: any) =>
    !value ? t("errors.markOption") : null;
  const validateCheckbox = (value: any) =>
    value.length === 0 ? t("errors.markAtLeastOneOption") : null;

  const form = useForm<WorkplaceHarassmentFormValues>({
    initialValues: {
      IP_001_genero: "",
      IP_002_edad: "",
      IP_003_comunidad: "",
      IP_004_etnia: "",
      IL_002_turno: "",
      IL_003_tiempoTrabajando: "",
      IL_004_area: "",
      IL_005_contactoConClientes: "",
      IL_006_puestoDeTrabajo: "",
      IL_007_participacionEnComite: "",
      IL_008_jefe: "",
      IL_009_centroDeTrabajo: "",
      SP_001_conocePoliticaDePrevencion: "",
      SP_002_A_C_haSidoCapacitado: [],
      SP_003_canalDeDenunciasExiste: "",
      SP_012_conoceProcesoDeInvestigacion: "",
      TOL_001AS: "",
      TOL_002AS: "",
      TOL_003AS: "",
      TOL_004AS: "",
      TOL_005AS: "",
      TOL_006AS: "",
      TOL_007AS: "",
      TOL_001AL: "",
      TOL_002AL: "",
      TOL_003AL: "",
      TOL_004AL: "",
      TOL_005AL: "",
      TOL_006AL: "",
      TOL_007AL: "",
      CPT_001: "",
      CPT_002: "",
      CPT_003: "",
      CPT_004: "",
      AT_001_007AS: [],
      AT_001_007AL: [],
      FRE_001AS: "",
      FRE_001AL: "",
      PAD_001_002AS: [],
      PAD_003_007AS: [],
      PAD_001_002AL: [],
      PAD_003_007AL: [],
      AA_001_009AS: [],
      AA_001_009AL: [],
      BAD_001_008AS: [],
      BAD_008AS: "",
      BAD_001_008AL: [],
      BAD_008AL: "",
      T_001_007AS: [],
      T_001_007AL: [],
      ACT_001_008: [],
      CASE_AS_CASE_RESOLUTION: "",
      CASE_AS_NORMALIZATION: "",
      CASE_AS_VICTIM_RESPONSIBILITY: "",
      CASE_AS_EXACERBATED_INTENT: "",
      CASE_AL_CASE_RESOLUTION: "",
      CASE_AL_NORMALIZATION: "",
      CASE_AL_VICTIM_RESPONSIBILITY: "",
      CASE_AL_EXACERBATED_INTENT: "",
      CON_001: "",
      CON_003: "",
      CON_004: "",
      CON_005: "",
      CON_006: "",
      CON_007: "",
      SAT_001: "",
    },

    validate: {
      IP_001_genero: (value) => validateField(value),
      IP_002_edad: (value) => validateField(value),
      IP_003_comunidad: (value) => validateField(value),
      IP_004_etnia: (value) => validateField(value),
      IL_002_turno: (value) => validateField(value),
      IL_003_tiempoTrabajando: (value) => validateField(value),
      IL_004_area: (value) => validateField(value),
      IL_005_contactoConClientes: (value) => validateField(value),
      IL_006_puestoDeTrabajo: (value) => validateField(value),
      IL_007_participacionEnComite: (value) => validateField(value),
      IL_008_jefe: (value) => validateField(value),
      IL_009_centroDeTrabajo: (value) => validateField(value),
      SP_001_conocePoliticaDePrevencion: (value) => validateField(value),
      SP_002_A_C_haSidoCapacitado: (value) => validateCheckbox(value),
      SP_003_canalDeDenunciasExiste: (value) => validateField(value),
      SP_012_conoceProcesoDeInvestigacion: (value) => validateField(value),
      TOL_001AS: (value) => validateField(value),
      TOL_002AS: (value) => validateField(value),
      TOL_003AS: (value) => validateField(value),
      TOL_004AS: (value) => validateField(value),
      TOL_005AS: (value) => validateField(value),
      TOL_006AS: (value) => validateField(value),
      TOL_007AS: (value) => validateField(value),
      TOL_001AL: (value) => validateField(value),
      TOL_002AL: (value) => validateField(value),
      TOL_003AL: (value) => validateField(value),
      TOL_004AL: (value) => validateField(value),
      TOL_005AL: (value) => validateField(value),
      TOL_006AL: (value) => validateField(value),
      TOL_007AL: (value) => validateField(value),
      CPT_001: (value) => validateField(value),
      CPT_002: (value) => validateField(value),
      CPT_003: (value) => validateField(value),
      CPT_004: (value) => validateField(value),
      AT_001_007AS: (value) => validateCheckbox(value),
      AT_001_007AL: (value) => validateCheckbox(value),
      FRE_001AS: (value) => validateField(value),
      PAD_001_002AS: (value) => validateCheckbox(value),
      PAD_003_007AS: (value) => validateCheckbox(value),
      AA_001_009AS: (value) => validateCheckbox(value),
      BAD_001_008AS: (value) => validateCheckbox(value),
      BAD_008AS: (value) => {
        for (let i = 0; i < form.values.BAD_001_008AS.length; i++) {
          if (form.values.BAD_001_008AS[i] === "BAD_008AS") {
            return validateField(value);
          }
        }
        return null;
      },
      FRE_001AL: (value) => validateField(value),
      PAD_001_002AL: (value) => validateCheckbox(value),
      PAD_003_007AL: (value) => validateCheckbox(value),
      AA_001_009AL: (value) => validateCheckbox(value),
      BAD_001_008AL: (value) => validateCheckbox(value),
      BAD_008AL: (value) => {
        for (let i = 0; i < form.values.BAD_001_008AL.length; i++) {
          if (form.values.BAD_001_008AL[i] === "BAD_008AL") {
            return validateField(value);
          }
        }
        return null;
      },
      T_001_007AS: (value) => validateCheckbox(value),
      T_001_007AL: (value) => validateCheckbox(value),
      ACT_001_008: (value) => validateCheckbox(value),
      CASE_AS_CASE_RESOLUTION: (value) => validateField(value),
      CASE_AS_NORMALIZATION: (value) => validateField(value),
      CASE_AS_VICTIM_RESPONSIBILITY: (value) => validateField(value),
      CASE_AS_EXACERBATED_INTENT: (value) => validateField(value),
      CASE_AL_CASE_RESOLUTION: (value) => validateField(value),
      CASE_AL_NORMALIZATION: (value) => validateField(value),
      CASE_AL_VICTIM_RESPONSIBILITY: (value) => validateField(value),
      CASE_AL_EXACERBATED_INTENT: (value) => validateField(value),
      CON_001: (value) => validateField(value),
      CON_003: (value) => validateField(value),
      CON_004: (value) => validateField(value),
      CON_005: (value) => validateField(value),
      CON_006: (value) => validateField(value),
      CON_007: (value) => validateField(value),
      SAT_001: (value) => validateField(value),
    },
  });

  const sendSurvey = async () => {
    setLoading(true);

    if (survey) {
      const data = transformWorkplaceHarassmentSurveyData(
        form.values,
        survey,
        isLeader,
        esParteDeRecursosHumanos
      );
      if (mpCode && !isPreview) {
        await SurveyService.post(mpCode, data);
        localStorage.setItem(mpCode, "true");
      }
    }

    setLoading(false);
  };

  const tituloPregunta = (id: string) =>
    `Situación ${id}. Por favor lee la situación que se describe a continuación y te haremos algunas preguntas al respecto.`;

  const handlePrev = () => {
    embla?.scrollPrev(false);
    form.resetDirty();
  };

  const handleNext = async (submit: boolean = false) => {
    const currentSlide = embla?.slideNodes()[embla?.selectedScrollSnap() || 0];
    const isInfoSlide = currentSlide?.classList.contains("info");

    if (isInfoSlide) {
      embla?.scrollNext(false);
    } else {
      if (currentSlide) {
        const slideId = currentSlide.id.split(",");

        let validated = true;
        slideId.forEach((id) => {
          form.validateField(id);
          if (!form.isValid(id)) validated = false;
        });

        if (validated) {
          if (submit) {
            if (!isPreview) {
              try {
                await sendSurvey();
                navigate("/thank-you");
              } catch {}
            } else {
              navigate("/thank-you");
            }
          } else {
            embla?.scrollNext(false);
          }
        }
      }
    }
  };

  useEffect(() => {
    if (embla) {
      setTotalSlides(embla.slideNodes().length);
    }
  }, [form, embla]);

  useEffect(() => {
    const getSurveyData = async () => {
      if (!mpCode) return;

      try {
        if (isDemoMode) {
          const language = searchParams.get("language") || "es";
          i18n.changeLanguage(language);
          ApiWithoutToken.defaults.baseURL = `${BASE_URL}${language}`;
        }

        const surveyData = await SurveyService.get(mpCode);

        if (!isDemoMode) {
          i18n.changeLanguage(surveyData.client.preferred_language);
          ApiWithoutToken.defaults.baseURL = `${BASE_URL}${surveyData.client.preferred_language}`;
        }

        updateLogo(surveyData.client.logo);
        setSurvey(surveyData);

        if (!isPreview) {
          if (surveyData.staff_survey.ended_at) {
            const fechaVencimiento = new Date(
              surveyData.staff_survey.ended_at
            );
            fechaVencimiento.setDate(fechaVencimiento.getDate() + 1);
            fechaVencimiento.setHours(fechaVencimiento.getHours() + 5);
            const fechaActual = new Date();
            if (fechaActual > fechaVencimiento) {
              setEncuestaVencida(true);
            }
          } else {
            setEncuestaTodaviaNoHaSidoLanzada(true);
          }
        }
      } catch (error) {
        setError(t("errors.link"));
      }
    };

    getSurveyData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (error) {
    return (
      <Container size={1200}>
        <Text>{error}</Text>
      </Container>
    );
  }

  if (!mpCode) {
    return (
      <Container size={1200}>
        <Text>El enlace no es válido.</Text>
      </Container>
    );
  }

  if (survey && !encuestaVencida && !encuestaTodaviaNoHaSidoLanzada) {
    if (isDemoMode || !(localStorage.getItem(mpCode || "") && !isPreview)) {
      return (
        <Container size={1200}>
          {isDemoMode && (
            <Alert color="yellow" radius="md" mb="md">
              <Text weight={600}>{t("demoBanner.title")}</Text>
              <Text size="sm">{t("demoBanner.text")}</Text>
            </Alert>
          )}
          <form>
            <Carousel
              speed={90}
              mx="auto"
              getEmblaApi={setEmbla}
              withControls={false}
              draggable={false}
              withKeyboardEvents={false}
            >
              <Carousel.Slide className={`${classes.carouselSlide} info`}>
                <SurveyWelcome1 />
              </Carousel.Slide>
              <Carousel.Slide className={`${classes.carouselSlide} info`}>
                <SurveyWelcome2 />
              </Carousel.Slide>
              <Carousel.Slide className={`${classes.carouselSlide} info`}>
                <SurveyAcknowledgement />
              </Carousel.Slide>

              <Carousel.Slide
                className={classes.carouselSlide}
                id={
                  "IP_001_genero" +
                  (survey.staff_survey.flag_002 ? ",IP_002_edad" : "") +
                  (survey.staff_survey.flag_003 ? ",IP_003_comunidad" : "") +
                  (survey.staff_survey.flag_004 ? ",IP_004_etnia" : "")
                }
              >
                <InformacionPersonal
                  form={form}
                  staff_survey={survey.staff_survey}
                />
              </Carousel.Slide>

              <Carousel.Slide
                className={classes.carouselSlide}
                id={
                  (survey.staff_survey.flag_006
                    ? "IL_003_tiempoTrabajando,"
                    : "") +
                  "IL_005_contactoConClientes,IL_007_participacionEnComite,IL_008_jefe"
                }
              >
                <InformacionLaboralFija
                  form={form}
                  setParteDeRecursosHumanos={setParteDeRecursosHumanos}
                  staff_survey={survey.staff_survey}
                />
              </Carousel.Slide>

              <Carousel.Slide
                className={classes.carouselSlide}
                id={
                  (survey.staff_survey.flag_005 ? "IL_002_turno," : "") +
                  (survey.staff_survey.flag_007 ? "IL_004_area," : "") +
                  "IL_006_puestoDeTrabajo" +
                  (survey.staff_survey.flag_009
                    ? ",IL_009_centroDeTrabajo"
                    : "")
                }
              >
                <InformacionLaboralPersonalizable
                  form={form}
                  survey={survey}
                  setIsLeader={setIsLeader}
                />
              </Carousel.Slide>

              <Carousel.Slide className={`${classes.carouselSlide} info`}>
                <SurveyInfoPolitics />
              </Carousel.Slide>

              <Carousel.Slide
                className={classes.carouselSlide}
                id="SP_001_conocePoliticaDePrevencion,SP_003_canalDeDenunciasExiste,SP_002_A_C_haSidoCapacitado,SP_012_conoceProcesoDeInvestigacion"
              >
                <SistemaDePrevencion form={form} />
              </Carousel.Slide>

              <Carousel.Slide className={`${classes.carouselSlide} info`}>
                <SurveyInfoSituations />
              </Carousel.Slide>

              <Carousel.Slide
                className={classes.carouselSlide}
                id="TOL_001AS,TOL_002AS,TOL_003AS,TOL_004AS,TOL_005AS,TOL_006AS,TOL_007AS"
              >
                <ToleranciaAcosoSexual form={form} />
              </Carousel.Slide>

              <Carousel.Slide
                className={classes.carouselSlide}
                id="TOL_001AL,TOL_002AL,TOL_003AL,TOL_004AL,TOL_005AL,TOL_006AL,TOL_007AL"
              >
                <ToleranciaAcosoLaboral form={form} />
              </Carousel.Slide>

              <Carousel.Slide
                className={classes.carouselSlide}
                id="CPT_001,CPT_002,CPT_003,CPT_004"
              >
                <Conceptos form={form} />
              </Carousel.Slide>

              <Carousel.Slide className={`${classes.carouselSlide} info`}>
                <SurveyInfoPersonalExperience />
              </Carousel.Slide>
              <Carousel.Slide
                className={classes.carouselSlide}
                id="AT_001_007AS"
              >
                <HaSidoObjetoDeAcosoSexual
                  form={form}
                  setHaSidoObjetoDeAcosoSexual={setHaSidoObjetoDeAcosoSexual}
                />
              </Carousel.Slide>
              {haSidoObjetoDeAcosoSexual && (
                <>
                  <Carousel.Slide
                    className={classes.carouselSlide}
                    id="FRE_001AS"
                  >
                    <FrecuenciaAcosoSexual form={form} />
                  </Carousel.Slide>
                  <Carousel.Slide
                    className={classes.carouselSlide}
                    id="PAD_003_007AS"
                  >
                    <PreguntasPerfilAcosadorAcosoSexual form={form} />
                  </Carousel.Slide>
                  <Carousel.Slide
                    className={classes.carouselSlide}
                    id="PAD_001_002AS"
                  >
                    <GeneroAcosadorAcosoSexual form={form} />
                  </Carousel.Slide>

                  <Carousel.Slide
                    className={classes.carouselSlide}
                    id="AA_001_009AS"
                  >
                    <AccionesAcosoSexual
                      form={form}
                      setNoDenuncioAcosoSexual={setNoDenuncioAcosoSexual}
                    />
                  </Carousel.Slide>
                </>
              )}
              {haSidoObjetoDeAcosoSexual && noDenuncioAcosoSexual && (
                <Carousel.Slide
                  className={classes.carouselSlide}
                  id="BAD_001_008AS,BAD_008AS"
                >
                  <BarrerasDeDenunciaAcosoSexual form={form} />
                </Carousel.Slide>
              )}

              <Carousel.Slide
                className={classes.carouselSlide}
                id="AT_001_007AL"
              >
                <HaSidoObjetoDeAcosoLaboral
                  form={form}
                  setHaSidoObjetoDeAcosoLaboral={setHaSidoObjetoDeAcosoLaboral}
                />
              </Carousel.Slide>

              {haSidoObjetoDeAcosoLaboral && (
                <>
                  <Carousel.Slide
                    className={classes.carouselSlide}
                    id="FRE_001AL"
                  >
                    <FrecuenciaAcosoLaboral form={form} />
                  </Carousel.Slide>
                  <Carousel.Slide
                    className={classes.carouselSlide}
                    id="PAD_003_007AL"
                  >
                    <PreguntasPerfilAcosadorAcosoLaboral form={form} />
                  </Carousel.Slide>
                  <Carousel.Slide
                    className={classes.carouselSlide}
                    id="PAD_001_002AL"
                  >
                    <GeneroAcosadorAcosoLaboral form={form} />
                  </Carousel.Slide>

                  <Carousel.Slide
                    className={classes.carouselSlide}
                    id="AA_001_009AL"
                  >
                    <AccionesAcosoLaboral
                      form={form}
                      setNoDenuncioAcosoLaboral={setNoDenuncioAcosoLaboral}
                    />
                  </Carousel.Slide>
                </>
              )}
              {haSidoObjetoDeAcosoLaboral && noDenuncioAcosoLaboral && (
                <Carousel.Slide
                  className={classes.carouselSlide}
                  id="BAD_001_008AL,BAD_008AL"
                >
                  <BarrerasDeDenunciaAcosoLaboral form={form} />
                </Carousel.Slide>
              )}

              <Carousel.Slide
                className={classes.carouselSlide}
                id="T_001_007AS"
              >
                <HaSidoTestigoDeAcosoSexual
                  form={form}
                  setHaSidoTestigoDeAcosoSexual={setHaSidoTestigoDeAcosoSexual}
                />
              </Carousel.Slide>

              <Carousel.Slide
                className={classes.carouselSlide}
                id="T_001_007AL"
              >
                <HaSidoTestigoDeAcosoLaboral
                  form={form}
                  setHaSidoTestigoDeAcosoLaboral={
                    setHaSidoTestigoDeAcosoLaboral
                  }
                />
              </Carousel.Slide>

              {(haSidoTestigoDeAcosoSexual || haSidoTestigoDeAcosoLaboral) && (
                <Carousel.Slide
                  className={classes.carouselSlide}
                  id="ACT_001_008"
                >
                  <AccionesTestigos form={form} />
                </Carousel.Slide>
              )}
              {(isLeader || esParteDeRecursosHumanos) && (
                <>
                  <Carousel.Slide className={`${classes.carouselSlide} info`}>
                    <SurveyInfoCasos />
                  </Carousel.Slide>
                  <Carousel.Slide
                    className={classes.carouselSlide}
                    id="CASE_AS_CASE_RESOLUTION,CASE_AS_NORMALIZATION,CASE_AS_VICTIM_RESPONSIBILITY,CASE_AS_EXACERBATED_INTENT"
                  >
                    <CasoAcosoSexual
                      form={form}
                      caso={survey.cases.first}
                      title={tituloPregunta("1")}
                    />
                  </Carousel.Slide>
                  <Carousel.Slide
                    className={classes.carouselSlide}
                    id="CASE_AL_CASE_RESOLUTION,CASE_AL_NORMALIZATION,CASE_AL_VICTIM_RESPONSIBILITY,CASE_AL_EXACERBATED_INTENT"
                  >
                    <CasoAcosoLaboral
                      form={form}
                      caso={survey.cases.second}
                      title={tituloPregunta("2")}
                    />
                  </Carousel.Slide>
                </>
              )}

              <Carousel.Slide className={`${classes.carouselSlide} info`}>
                <SurveyInfoTratamientoDeCasos />
              </Carousel.Slide>

              <Carousel.Slide
                className={classes.carouselSlide}
                id="CON_001,CON_003,CON_004,CON_005,CON_006,CON_007"
              >
                <PreguntasConfianzaEnLaOrganizacion form={form} />
              </Carousel.Slide>
              <Carousel.Slide className={classes.carouselSlide} id="SAT_001">
                <PreguntaSatisfaccion form={form} />
              </Carousel.Slide>
            </Carousel>
          </form>
          <Progress
            value={scrollProgress}
            styles={{
              bar: { transitionDuration: "0ms" },
              root: { maxWidth: "100%" },
            }}
            size="sm"
            mt="xl"
            mx="auto"
            color="#d92020"
          />
          <Group position="apart">
            <Text color="dimmed" size="xs">
              <>
                {t("page")} {(embla?.selectedScrollSnap() || 0) + 1} {t("of")}{" "}
                {totalSlides}
              </>
            </Text>
            <SurveyNavigationButtons
              embla={embla}
              handlePrev={handlePrev}
              handleNext={handleNext}
              disabled={!survey || loading}
            />
          </Group>
        </Container>
      );
    } else {
      return (
        <Container size={1200}>
          Ya has completado la encuesta. ¡Gracias por tu tiempo!
        </Container>
      );
    }
  } else if (encuestaVencida) {
    return (
      <Container size={1200}>
        <Title order={3}>¡La encuesta ya finalizó!</Title>
        <Text>Este link no se encuentra disponible.</Text>
      </Container>
    );
  } else if (encuestaTodaviaNoHaSidoLanzada) {
    return (
      <Container size={1200}>
        <Title order={3}>¡La encuesta todavía no ha sido lanzada!</Title>
        <Text>Este link no se encuentra disponible.</Text>
      </Container>
    );
  } else {
    return (
      <Container size={1200} h={550}>
        <Flex justify="center" align="center" h="100%">
          <Loader color="#d92020" />
        </Flex>
      </Container>
    );
  }
};
